import { RetryHandlerOptions } from '@microsoft/microsoft-graph-client'; 
import { RETRY_SETTINGS } from '../../AppConstants';

export const GRAPH_CLIENT_MIDDLEWARE_OPTIONS = [new RetryHandlerOptions(RETRY_SETTINGS.retryWaitMilliseconds / 1000 /*delay*/, RETRY_SETTINGS.maxRetries /*maxRetries*/)];